<template>
  <div class="flex flex-col items-center justify-center h-screen">
    <img
      src="https://storage.googleapis.com/komerce/assets/logo/logo-komerce-no-tag.svg"
      alt="logo"
      width="176px"
      class="mb-[40px]"
    >
    <h1 class="text-2xl font-semibold text-center">
      Integrasi Marketplace Berhasil 🎉
    </h1>
    <p class="text-sm text-gray-500 text-center mb-[40px] max-w-[500px]">
      Sekarang Toko mu telah terintegrasi dengan sistem Komerce. Lakukan mapping produk dengan produk di Tokomu agar produkmu tersinkronisasi dengan sistem Kompack.
    </p>
    <p class="text-sm text-gray-500 text-center max-w-[500px]">
      Halaman akan tertutup otomatis dalam <span class="font-semibold">{{ countdown }}</span> detik
    </p>
  </div>
</template>

<script>
export default {
  name: 'IntegratedSuccesfullyPage',
  data() {
    return {
      countdown: 5,
    }
  },
  mounted() {
    this.startCountdown()
  },
  methods: {
    /**
     * Start the countdown to close the page
     */
    startCountdown() {
      const interval = setInterval(() => {
        this.countdown -= 1
        if (this.countdown <= 0) {
          clearInterval(interval)
          this.notifyParentAndClose()
        }
      }, 1000)
    },
    /**
     * Notify the parent iframe that the integration is successful
     */
    notifyParentAndClose() {
      if (window.opener) {
        window.opener.postMessage({
          type: 'INTEGRATION_SUCCESS',
          data: {
            integration_success: true,
          },
        }, '*')
      }
    },
  },
}
</script>
